import Cookies from 'universal-cookie';
import { ADMIN_API_URL } from 'src/config';

const cookies = new Cookies();

// Helper to get headers
const getAuthHeader = () => {
    const token = cookies.get('_root_auth_token');
    return { 'Authorization': `Bearer ${token}` };
};

const handleResponse = (response) => {
    return response.text().then(text => {
        let data;
        try {
            data = text ? JSON.parse(text) : {};
        } catch (e) {
            data = { message: text };
        }
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
};

function getDraftBanners(bannerType) {
    const requestOptions = {
        method: 'GET',
        headers: { ...getAuthHeader() }
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/draft/banners?bannerType=${bannerType}`, requestOptions)
        .then(handleResponse);
}

function getPublishedBanners(bannerType) {
    const requestOptions = {
        method: 'GET',
        headers: { ...getAuthHeader() }
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/published/banners?bannerType=${bannerType}`, requestOptions)
        .then(handleResponse);
}

function getDraftBannerDetail(bannerNo) {
    const requestOptions = {
        method: 'GET',
        headers: { ...getAuthHeader() }
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/draft/banners/${bannerNo}`, requestOptions)
        .then(handleResponse);
}

function upsertDraftBanner(formData) {
    const requestOptions = {
        method: 'POST',
        headers: { ...getAuthHeader() }, 
        body: formData
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/draft/banners`, requestOptions)
        .then(handleResponse);
}

function deleteDraftBanner(bannerNo) {
    const requestOptions = {
        method: 'DELETE',
        headers: { ...getAuthHeader() }
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/draft/banners/${bannerNo}`, requestOptions)
        .then(handleResponse);
}

function updateBannerOrder(bannerType, bannerNos) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify({ bannerType, bannerNos })
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/draft/order`, requestOptions)
        .then(handleResponse);
}

function publishBanners() {
    const requestOptions = {
        method: 'POST',
        headers: { ...getAuthHeader() }
    };
    return fetch(`${ADMIN_API_URL}/banner-releases/draft/publish`, requestOptions)
        .then(handleResponse);
}

export const bannerReleaseService = {
    getDraftBanners,
    getPublishedBanners,
    getDraftBannerDetail,
    upsertDraftBanner,
    deleteDraftBanner,
    updateBannerOrder,
    publishBanners
};
